<template>
  <div class="CovidiabReport">
    <img src="/covidiab-algerie/covidiab-algerie-vignette-rapport.png" style="width: 100%"/>
    <div style="height: 50px"></div>
    <div v-if="report.patient.profile.centre_hospitalier || report.patient.profile.diabetologue || report.patient.profile.medecin_traitant">
      <h2>Le patient déclare être suivi par :</h2>
      <v-divider/>
      <div><span class="Question">Médecin traitant :</span> <span class="Reponse">{{report.patient.profile.medecin_traitant}}</span></div>
      <div><span class="Question">Diabétologue :</span> <span class="Reponse">{{report.patient.profile.diabetologue}}</span></div>
      <div><span class="Question">Centre hospitalier :</span> <span class="Reponse">{{report.patient.profile.centre_hospitalier}}</span></div>
    </div>
    <div class="my-9">
      <h2>Historique des alertes de ce patient : </h2>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Type</th>
            <th class="text-left">Date</th>
            <th>Traitement</th>
            <th>Commentaires</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="alert in report.data.alerts"
              :key="alert.id">
            <td><span :style="{color: (alert.level === 'LEVEL_RED') ? 'red' : 'orange'}">{{ alertLabels[alert.level] }}</span></td>
            <td>{{ alert.created_at | moment('L - LT') }}</td>
            <td>
              <span v-if="alert.seen_at">Traitée par {{alert.doctor.first_name}} {{alert.doctor.last_name}} le {{alert.seen_at | moment('L à LT')}}</span>
            </td>
            <td>
              {{alert.seen_comments}}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="my-9">
      <h3>Derniers symptômes signalés :</h3>
      <v-divider/>
      <div v-if="report.data.symptoms && report.data.symptoms.version === 1">
        <div class="mt-5" v-if="report.data.symptoms.data.malaise === 10 || report.data.symptoms.data.geneRespiratoire === 10">
          <h4>Symptômes responsables d'une <span style="color: red">alerte rouge</span> : </h4>
          <ul>
            <li v-show="report.data.symptoms.data.malaise === 10">Malaise</li>
            <li v-show="report.data.symptoms.data.geneRespiratoire === 10">Gène respiratoire</li>
          </ul>
        </div>
        <div class="mt-5" v-else-if="report.data.symptoms.data.toux === 1 && report.data.symptoms.data.fievre === 1">
          <h4>Symptômes responsables d'une <span style="color: darkorange">alerte orange</span> : </h4>
          <ul>
            <li v-show="report.data.symptoms.data.toux === 1">Toux</li>
            <li v-show="report.data.symptoms.data.fievre === 1">Fièvre</li>
          </ul>
        </div>
        <div class="mt-5">
          <h4>Tous les symptômes signalés :</h4>
          <ul>
            <li v-if="report.data.symptoms.data.toux === 1">Toux</li>
            <li v-if="report.data.symptoms.data.fievre === 1">Fièvre</li>
            <li v-if="report.data.symptoms.data.malaise === 10">Malaise</li>
            <li v-if="report.data.symptoms.data.geneRespiratoire === 10">Gène respiratoire</li>
          </ul>
        </div>
      </div>
      <div v-else-if="report.data.symptoms && report.data.symptoms.version === 2">
        <div class="mt-5" v-if="report.data.symptoms.data.nb_majeurs > 0">
          <h4>Symptômes responsables d'une <span style="color: red">alerte rouge</span> : </h4>
          <ul>
            <li v-show="report.data.symptoms.data.alimentation === 0">Impossibilité de s'allimenter ou de boire depuis 24h ou plus</li>
            <li v-show="report.data.symptoms.data.manqueSouffle === 0">Manque de souffle inhabituel</li>
          </ul>
        </div>
        <div class="mt-5" v-else-if="report.data.symptoms.data.nb_mineurs === 2">
          <h4>Symptômes responsables d'une <span style="color: darkorange">alerte orange</span> : </h4>
          <ul>
            <li v-show="report.data.symptoms.data.fatigueExtreme === 0">Fatigue inhabituelle extrême</li>
            <li v-show="report.data.symptoms.data.fievre === 0">Fièvre de plus de 39°C</li>
          </ul>
        </div>
        <div class="mt-5">
          <h4>Tous les symptômes signalés :</h4>
          <ul>
            <li v-if="report.data.symptoms.data.toux === 0">Toux</li>
            <li v-if="report.data.symptoms.data.fievre === 0">Fièvre</li>
            <li v-if="report.data.symptoms.data.fatigue === 0">Fatigue inhabituelle</li>
            <li v-if="report.data.symptoms.data.fatigueExtreme === 0">Fatigue inhabituelle extrême</li>
            <li v-if="report.data.symptoms.data.diarrhee === 0">Diarrhée</li>
            <li v-if="report.data.symptoms.data.douleurs === 0">Courbatures</li>
            <li v-if="report.data.symptoms.data.perteSens === 0">Perte du goût ou de l'odorat</li>
            <li v-if="report.data.symptoms.data.alimentation === 0">Impossibilité de s'alimenter ou de boire depuis 24h ou plus</li>
            <li v-if="report.data.symptoms.data.manqueSouffle === 0">Manque de souffle inhabituel en parlant ou en faisant un petit effort</li>
          </ul>
        </div>
      </div>
      <div v-else>
        Aucun symptôme signalé.
      </div>
    </div>
    <div>
      <h2 class="mb-5">Sexe et date de naissance :</h2>
      <div class="BlocQR">
        <div class="Question">Sexe : </div>
        <span class="Reponse" v-if="report.data.gender !== null">{{report.data.gender | moment('L')}}</span>
        <span class="Reponse" v-else>Non renseigné</span>
      </div>
      <div class="BlocQR">
        <div class="Question">Date de naissance : </div>
        <span class="Reponse" v-if="report.data.birthdate !== null">{{report.data.birthdate | moment('L')}}</span>
        <span class="Reponse" v-else>Non renseigné</span>
      </div>
      <div class="BlocQR">
        <div class="Question">Ville : </div>
        <span class="Reponse" v-if="report.patient.profile.ville !== null">{{report.patient.profile.ville}}</span>
        <span class="Reponse" v-else>Non renseigné</span>
      </div>
    </div>
    <div class="my-5">
      <h2>Derniers résultats Anxiété et Dépression :</h2>
      <v-divider/>
      <div v-if="anxiete_depression">
        <p>Score d'anxiete : {{anxiete_depression.anxiete}}</p>
        <p>Score de depression : {{anxiete_depression.depression}}</p>
      </div>
      <div v-else>Ce questionnaire n'a pas été rempli</div>
    </div>
    <div class="my-5">
      <h2>Questionnaire « Nouveau questionnaire santé - 02/04/2020 »</h2>
      <v-divider/>
      <div v-if="q3">

        <div class="BlocQR">
          <div class="Question">Avez-vous de l’hypertension artérielle mal équilibrée ?</div>
          <span class="Reponse" v-if="q3.hypertension === 0">Oui</span>
          <span class="Reponse" v-if="q3.hypertension === 1">Non</span>
          <span class="Reponse" v-if="q3.hypertension === 2">Je ne sais pas</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous une maladie cardiaque ou vasculaire ?</div>
          <span class="Reponse" v-if="q3.maladieCardiaque === 0">Oui</span>
          <span class="Reponse" v-if="q3.maladieCardiaque === 1">Non</span>
          <span class="Reponse" v-if="q3.maladieCardiaque === 2">Je ne sais pas</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Prenez-vous un traitement à visée cardiologique ?</div>
          <span class="Reponse" v-if="q3.traitementCardiologique === 0">Oui</span>
          <span class="Reponse" v-if="q3.traitementCardiologique === 1">Non</span>
          <span class="Reponse" v-if="q3.traitementCardiologique === 2">Je ne sais pas</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous ou avez-vous eu un cancer dans les 3 dernières années ?</div>
          <span class="Reponse" v-if="q3.cancer === 0">Oui</span>
          <span class="Reponse" v-if="q3.cancer === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous une maladie respiratoire ?</div>
          <span class="Reponse" v-if="q3.maladieRespiratoire === 0">Oui</span>
          <span class="Reponse" v-if="q3.maladieRespiratoire === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Êtes-vous suivi par un pneumologue ?</div>
          <span class="Reponse" v-if="q3.pneumologue === 0">Oui</span>
          <span class="Reponse" v-if="q3.pneumologue === 1">Non</span>
          <span class="Reponse" v-if="q3.pneumologue === 2">Je ne sais pas</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous une insuffisance rénale chronique dialysée ?</div>
          <span class="Reponse" v-if="q3.insufisanceRenale === 0">Oui</span>
          <span class="Reponse" v-if="q3.insufisanceRenale === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous une maladie chronique du foie ?</div>
          <span class="Reponse" v-if="q3.maladieFoie === 0">Oui</span>
          <span class="Reponse" v-if="q3.maladieFoie === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Êtes-vous enceinte ?</div>
          <span class="Reponse" v-if="q3.enceinte === 0">Oui</span>
          <span class="Reponse" v-if="q3.enceinte === 1">Non</span>
          <span class="Reponse" v-if="q3.enceinte === undefined || q3.enceinte === 2">Non applicable</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous une maladie connue pour diminuer vos défenses immunitaires</div>
          <span class="Reponse" v-if="q3.maladieImmunitaire === 0">Oui</span>
          <span class="Reponse" v-if="q3.maladieImmunitaire === 1">Non</span>
          <span class="Reponse" v-if="q3.maladieImmunitaire === 2">Je ne sais pas</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Prenez-vous un traitement immunosuppresseur ?</div>
          <span class="Reponse" v-if="q3.traitementImmunosuppresseur === 0">Oui</span>
          <span class="Reponse" v-if="q3.traitementImmunosuppresseur === 1">Non</span>
          <span class="Reponse" v-if="q3.traitementImmunosuppresseur === 2">Je ne sais pas</span>
        </div>
      </div>
      <div v-else style="font-size: 18px; font-weight: bold;">
        Ce questionnaire n'a pas été complété
      </div>
    </div>
    <div class="my-5">
      <h2>Questionnaire « Faisons connaissance »</h2>
      <v-divider/>
      <div v-if="q1">
        <div>
          <div class="BlocQR">
            <div class="Question">Pour quel type de diabète êtes-vous traité :</div>
            <span class="Reponse" v-if="q1.typeDiabete === 0">Diabète de type 1</span>
            <span class="Reponse" v-if="q1.typeDiabete === 1">Diabète de type 2</span>
            <span class="Reponse" v-if="q1.typeDiabete === 2">Autre</span>
            <span class="Reponse" v-if="q1.typeDiabete === 3">Je ne sais pas</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Etes-vous traité(e) par insuline :</div>
            <span class="Reponse" v-if="q1.traitementInsuline === 0">Oui</span>
            <span class="Reponse" v-if="q1.traitementInsuline === 1">Non</span>
          </div>

          <div class="BlocQR" v-if="q1.traitementInsuline === 0">
            <div class="Question">Combien d’injections d’insuline faites-vous :</div>
            <span class="Reponse" v-if="q1.nbInjections === 0">1</span>
            <span class="Reponse" v-if="q1.nbInjections === 1">2</span>
            <span class="Reponse" v-if="q1.nbInjections === 2">3</span>
            <span class="Reponse" v-if="q1.nbInjections === 3">4 et plus</span>
            <span class="Reponse" v-if="q1.nbInjections === 4">Pompe à insuline</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Quels médicaments prenez-vous :</div>
            <div class="Reponse" v-html="nl2br(q1.listeMedicaments)"></div>
          </div>

          <div class="BlocQR">
            <div class="Question">Connaissez-vous votre dernière valeur d’hémoglobine glyquée :</div>
            <span class="Reponse" v-if="q1.connaitreMesure === 0">Oui</span>
            <span class="Reponse" v-if="q1.connaitreMesure === 1">Non</span>
          </div>

          <div class="BlocQR" v-if="q1.connaitreMesure === 0">
            <div class="Question">Date de la mesure :</div>
            <div class="Reponse">{{q1.dateMesure | moment('L')}}</div>
          </div>

          <div class="BlocQR" v-if="q1.connaitreMesure === 0">
            <div class="Question">Valeur de la mesure :</div>
            <div class="Reponse">{{q1.valeurMesue}}%</div>
          </div>

          <div class="BlocQR">
            <div class="Question">Rétinopathie :</div>
            <span class="Reponse" v-if="q1.retinopathie.checked">Oui</span>
            <span class="Reponse" v-else>Non</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Néphropathie :</div>
            <span class="Reponse" v-if="q1.nephropathie.checked">Oui</span>
            <span class="Reponse" v-else>Non</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Pied (plaie du pied ou amputation au niveau du pied) :</div>
            <span class="Reponse" v-if="q1.plaiePied.checked">Oui</span>
            <span class="Reponse" v-else>Non</span>
          </div>

          <div class="BlocQR">
            <div class="Question">AVC ou attaque cérébrale :</div>
            <span class="Reponse" v-if="q1.avc.checked">Oui</span>
            <span class="Reponse" v-else>Non</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Je ne sais pas :</div>
            <span class="Reponse" v-if="q1.organeToucheJeNeSaisPas.checked">Oui</span>
            <span class="Reponse" v-else>Non</span>
          </div>

          <div class="BlocQR">
            <div class="Question">Etes-vous traité pour de l’hypertension artérielle :</div>
            <span class="Reponse" v-if="q1.traiteHypertenion === 0">Oui</span>
            <span class="Reponse" v-if="q1.traiteHypertenion === 1">Non</span>
          </div>

          <div class="BlocQR" v-if="q1.traiteHypertenion === 0">
            <div class="Question">Sur une échelle de 1 à 10 (1 je ne prends pas mes médicaments, 10 je prends toujours
              tous mes médicaments), comment vous situez-vous :
            </div>
            <div class="Reponse">{{q1.evaMedicaments}}</div>
          </div>
        </div>
      </div>
      <div v-else style="font-size: 18px; font-weight: bold;">
        Ce questionnaire n'a pas été complété
      </div>
    </div>
    <div class="my-5">
      <h2>Questionnaire « Encore quelques questions pour mieux vous connaître »</h2>
      <v-divider/>
      <div v-if="q2">
        <div>Êtes-vous ou avez-vous été sujet à :</div>
        <div class="BlocQR">
          <div class="Question">Une maladie des poumons et des voies respiratoires :</div>
          <span class="Reponse" v-if="q2.maladiePoumons === 0">Oui</span>
          <span class="Reponse" v-if="q2.maladiePoumons === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Un problème cardiaque :</div>
          <span class="Reponse" v-if="q2.problemeCardiaque === 0">Oui</span>
          <span class="Reponse" v-if="q2.problemeCardiaque === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Un accident vasculaire cérébral :</div>
          <span class="Reponse" v-if="q2.avc === 0">Oui</span>
          <span class="Reponse" v-if="q2.avc === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Une maladie du tube digestif et/ou du foie :</div>
          <span class="Reponse" v-if="q2.maladieFoie === 0">Oui</span>
          <span class="Reponse" v-if="q2.maladieFoie === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Une maladie des reins :</div>
          <span class="Reponse" v-if="q2.maladieReins === 0">Oui</span>
          <span class="Reponse" v-if="q2.maladieReins === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous déjà été malade d'un cancer :</div>
          <span class="Reponse" v-if="q2.maladeCancer === 0">Oui</span>
          <span class="Reponse" v-if="q2.maladeCancer === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Une autre maladie que celles qui sont proposées :</div>
          <div class="Reponse" v-html="nl2br(q2.autreMaladie)"></div>
        </div>

        <div class="BlocQR">
          <div class="Question">Avez-vous eu une ou plusieurs chirurgie(s) bariatrique(s) :</div>
          <span class="Reponse" v-if="q2.chirurgieBariatrique === 0">Oui</span>
          <span class="Reponse" v-if="q2.chirurgieBariatrique === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Anneau gastrique :</div>
          <span class="Reponse" v-if="q2.anneauGastrique === 0">Oui</span>
          <span class="Reponse" v-if="q2.anneauGastrique === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Sleeve :</div>
          <span class="Reponse" v-if="q2.sleeve === 0">Oui</span>
          <span class="Reponse" v-if="q2.sleeve === 1">Non</span>
        </div>

        <div class="BlocQR">
          <div class="Question">Bypass :</div>
          <span class="Reponse" v-if="q2.bypass === 0">Oui</span>
          <span class="Reponse" v-if="q2.bypass === 1">Non</span>
        </div>
      </div>
      <div v-else style="font-size: 18px; font-weight: bold;">
        Ce questionnaire n'a pas été complété
      </div>
    </div>
  </div>
</template>

<script>
  import MissionHeaderBlock from 'components/blocks/MissionHeaderBlock'
  import ParagraphBlock from 'components/blocks/ParagraphBlock'
  import SubHeaderBlock from 'components/blocks/SubHeaderBlock'

  export default {
    components: {
      SubHeaderBlock,
      MissionHeaderBlock,
      ParagraphBlock
    },

    computed: {
      alertLabels () {
        return {
          LEVEL_RED: 'Rouge',
          LEVEL_ORANGE: 'Orange'
        }
      },

      q3() {
        let tmp = this.report.data.data.filter(d => d.module_id === this.report.data.config.q3)[0];

        if (tmp) {
          return tmp.data.quiz;
        } else {
          return null;
        }
      },

      q1() {
        let tmp = this.report.data.data.filter(d => d.module_id === this.report.data.config.q1)[0];

        if (tmp) {
          return tmp.data.quiz;
        } else {
          return null;
        }
      },

      q2() {
        let tmp = this.report.data.data.filter(d => d.module_id === this.report.data.config.q2)[0];

        if (tmp) {
          return tmp.data['etes-vous-ou-avez-vous-ete-sujet-a'];
        } else {
          return null;
        }
      },

      anxiete_depression() {
        let tmp = this.report.data.anxiete;

        if (tmp === null || tmp === undefined) {
          return null;
        }

        let total = tmp.ralenti + tmp.optimisme + tmp.savoirRire + tmp.etreHeureux + tmp.resterAssis + tmp.tenduEnerve + tmp.faireDuSouci + tmp.paniqueSoudaine + tmp.sensationDePeur + tmp.interetApparence + tmp.interetLivreTele + tmp.plaisirChosesQueJAime;

        let anxiete = total % 100;
        let depression = (total - anxiete) / 100;

        return {
          anxiete: anxiete,
          depression: depression,
        }
      },
    },

    methods: {
      nl2br (str) {
        let breakTag = '<br />';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
    },

    props: {
      report: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .CovidiabReport {
    font-size: 16px;

    .BlocQR {
      margin-bottom: 25px;
    }

    .Reponse {
      font-weight: bold;
      margin-left: 10px;
    }

    .Question {
    }
  }
</style>
